<!--suppress AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a href="javascript:void(0);">
        <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </a>
    </li>
    <li class="breadcrumb-item active" aria-current="page" translate>Balance</li>
    <li class="breadcrumb-item">
      <a href="https://www.youtube.com/watch?v=I4LQle6mrLg" target="_blank">
        <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <g id="Group">
            <path id="Path" fill="#06209f" stroke="none"
                  d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
          </g>
          <g id="g1"/>
        </svg>
      </a>
    </li>
  </ol>
</nav>
<div [hidden]="loading">
  <div class="bg-white d-flex p-3 flex-row-reverse widget box box-shadow">
    <div class="d-flex flex-row my-auto">
      <div translate style="font-size: 18pt" class="my-auto mx-2 align-middle">Balance</div>
      <div *ngIf="myBusiness" translate class="font-weight-bolder mx-2 my-auto align-middle" [ngClass]="myBusiness.walletAmount < 0? 'text-danger' : 'text-success'" style="font-size: 22pt;">{{myBusiness.walletAmount | number: '1.2-2'}} <img height="32" [src]="myBusiness.walletAmount < 0? 'assets/srr.svg' : 'assets/srg.svg'"></div>
      <div *ngIf="!myBusiness" translate class="font-weight-bolder mx-2 my-auto align-middle" style="font-size: 22pt;">{{0 | number: '1.2-2'}} <img height="32" src="assets/sr.svg"></div>
      <div *ngIf="myBusiness && myBusiness.pendingWithdrawsAmount" translate class="mx-1 my-auto align-middle text-primary" style="font-size: 8pt;">({{'Under Transfer' | translate}} {{myBusiness.pendingWithdrawsAmount | number: '1.2-2'}} <img height="32" src="assets/sr.svg">)</div>
    </div>
  </div>
  <!-- content -->
  <div class="statbox widget box box-shadow mt-4">
    <div class="widget-content widget-content-area icon-tab">
      <ul class="nav nav-tabs  mb-3 mt-3" id="iconTab" role="tablist">
        <!-- Sales Tab -->
        <li class="nav-item">
          <a class="nav-link active" id="icon-sales-tab" data-toggle="tab" href="#icon-sales" role="tab" aria-controls="icon-sales" aria-selected="false">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trending-up">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
              <polyline points="17 6 23 6 23 12"></polyline>
            </svg>
            {{'Sales' | translate}}</a>
        </li>
        <!-- Withdraw Tab -->
        <li class="nav-item">
          <a class="nav-link" id="icon-withdraws-tab" data-toggle="tab" href="#icon-withdraws" role="tab" aria-controls="icon-withdraws" aria-selected="false">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39">
              <path class="cls-1" d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/>
              <path class="cls-1" d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/>
            </svg>
            {{'Withdraws' | translate}}</a>
        </li>
        <!-- Subscriptions Tab -->
        <li class="nav-item">
          <a class="nav-link" id="icon-subscriptions-tab" data-toggle="tab" href="#icon-subscriptions" role="tab" aria-controls="icon-subscriptions" aria-selected="false">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-award">
              <circle cx="12" cy="8" r="7"></circle>
              <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
            </svg>
            {{'Subscription Fees' | translate}}</a>
        </li>
        <!-- Sales Tab -->
        <li class="nav-item">
          <a class="nav-link" id="icon-sales-charts-tab" data-toggle="tab" href="#icon-sales-chart" role="tab" aria-controls="icon-sales-chart" aria-selected="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-activity">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
            </svg>
            {{'Sales Chart' | translate}}</a>
        </li>
        <!---->
      </ul>
      <div class="tab-content">
        <!-- Sales tab content -->
        <div class="tab-pane fade active show" id="icon-sales" role="tabpanel" aria-labelledby="icon-sales-tab">
          <div class="table-responsive mb-4 mt-4">
            <table id="sales-extension" class="table table-hover non-hover" style="width:100%">
              <thead>
              <tr>
                <th translate>Invoice No</th>
                <th translate>Amount</th>
                <th translate>Fees</th>
                <th translate>Fees VAT</th>
                <th translate>Note</th>
                <th translate>Client Name</th>
                <th translate>Client Mobile</th>
                <th translate>Date</th>
                <th translate>Settled</th>
                <th translate>IBAN Settled</th>
                <th translate>Settled Date</th>
              </tr>
              </thead>
            </table>
          </div>
        </div>
        <!-- end tab content -->
        <!-- tab Withdraws content -->
        <div class="tab-pane fade" id="icon-withdraws" role="tabpanel" aria-labelledby="icon-withdraws-tab">
          <div class="table-responsive mb-4 mt-4">
            <table id="withdraws-extension" class="table table-hover non-hover" style="width:100%">
              <thead>
              <tr>
                <th translate>Bank Name</th>
                <th translate>IBAN</th>
                <th translate>Amount</th>
                <th translate>Fees</th>
                <th translate>Transaction Number</th>
                <th translate>Date</th>
                <th translate>Is Transferred</th>
                <th translate>Receiver Name</th>
              </tr>
              </thead>
            </table>
          </div>
        </div>
        <!-- end tab content-->
        <!-- Subscriptions tab content -->
        <div class="tab-pane fade show" id="icon-subscriptions" role="tabpanel" aria-labelledby="icon-subscriptions-tab">
          <div class="table-responsive mb-4 mt-4">
            <table id="subscriptions-extension" class="table table-hover non-hover" style="width:100%">
              <thead>
              <tr>
                <th translate>Invoice No</th>
                <th translate>Amount</th>
                <th translate>Note</th>
                <th translate>Client Name</th>
                <th translate>Client Mobile</th>
                <th translate>Date</th>
              </tr>
              </thead>
            </table>
          </div>
        </div>
        <!-- end tab content -->
        <!-- tab Sales Chart content -->
        <div class="tab-pane fade" id="icon-sales-chart" role="tabpanel" aria-labelledby="icon-sales-chart-tab">
          <div class="table-responsive mb-4 mt-4">
            <div style="letter-spacing: normal !important;" id="revenueMonthly"></div>
          </div>
        </div>
        <!-- end tab content-->
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>

<div class="modal fade" id="excelDownloadModal" #excelDownloadModal tabindex="-1" role="dialog" aria-labelledby="excelDownloadModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="excelDownloadModalLabel">{{'Download Excel Report' | translate}}</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="excelDownloadForm">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="eYear" translate>Year</label>
                <div class="input-group">
                  <input [ngClass]="{'is-invalid': e.year.errors && excelDownloadSubmitted}" [placeholder]="'[YYYY] or empty for all' | translate" maxlength="4" type="text" formControlName="year" class="form-control" id="eYear">
                </div>
                <small class="form-text text-muted" translate>This is the year of the report.</small>
                <span class="invalid-feedback" *ngIf="excelDownloadSubmitted && e.year.errors && e.year.errors.required">This field is required</span>
                <span class="invalid-feedback" *ngIf="excelDownloadSubmitted && e.year.errors && e.year.errors.pattern">This field has invalid value</span>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="eMonth" translate>Month</label>
                <div class="input-group">
                  <select [ngClass]="{'is-invalid': e.month.errors && pdfDownloadSubmitted}" formControlName="month" class="form-control" id="eMonth">
                    <option value="" translate>[All]</option>
                    <option value="01" translate>Jan</option>
                    <option value="02" translate>Feb</option>
                    <option value="03" translate>Mar</option>
                    <option value="04" translate>Apr</option>
                    <option value="05" translate>May</option>
                    <option value="06" translate>Jun</option>
                    <option value="07" translate>Jul</option>
                    <option value="08" translate>Aug</option>
                    <option value="09" translate>Sep</option>
                    <option value="10" translate>Oct</option>
                    <option value="11" translate>Nov</option>
                    <option value="12" translate>Dec</option>
                  </select>
                </div>
                <small class="form-text text-muted" translate>This is the month of the report.</small>
                <span class="invalid-feedback" *ngIf="pdfDownloadSubmitted && e.month.errors && e.month.errors.required">This field is required</span>
                <span class="invalid-feedback" *ngIf="pdfDownloadSubmitted && e.month.errors && e.month.errors.pattern">This field has invalid value</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <button *ngIf="!submittingExcelDownload" class="btn btn-primary" translate (click)="submitExcelDownloadForm()">Download</button>&nbsp;&nbsp;&nbsp;&nbsp;
              <div *ngIf="submittingExcelDownload" class="mx-auto spinner-grow text-info loader-lg"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="pdfDownloadModal" #pdfDownloadModal tabindex="-1" role="dialog" aria-labelledby="pdfDownloadModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="pdfDownloadModalLabel">{{'Download PDF VAT Report' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body">
        <form [formGroup]="pdfDownloadForm">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="year" translate>Year</label>
                <div class="input-group">
                  <input [ngClass]="{'is-invalid': f.year.errors && pdfDownloadSubmitted}" placeholder="YYYY" maxlength="4" type="text" formControlName="year" class="form-control" id="year">
                </div>
                <small class="form-text text-muted" translate>This is the year of the report.</small>
                <span class="invalid-feedback" *ngIf="pdfDownloadSubmitted && f.year.errors && f.year.errors.required">This field is required</span>
                <span class="invalid-feedback" *ngIf="pdfDownloadSubmitted && f.year.errors && f.year.errors.pattern">This field has invalid value</span>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="month" translate>Month</label>
                <div class="input-group">
                  <select [ngClass]="{'is-invalid': f.month.errors && pdfDownloadSubmitted}" formControlName="month" class="form-control" id="month">
                    <option value="jan">Jan</option>
                    <option value="feb">Feb</option>
                    <option value="mar">Mar</option>
                    <option value="apr">Apr</option>
                    <option value="may">May</option>
                    <option value="jun">Jun</option>
                    <option value="jul">Jul</option>
                    <option value="aug">Aug</option>
                    <option value="sep">Sep</option>
                    <option value="oct">Oct</option>
                    <option value="nov">Nov</option>
                    <option value="dec">Dec</option>
                  </select>
                </div>
                <small class="form-text text-muted" translate>This is the month of the report.</small>
                <span class="invalid-feedback" *ngIf="pdfDownloadSubmitted && f.month.errors && f.month.errors.required">This field is required</span>
                <span class="invalid-feedback" *ngIf="pdfDownloadSubmitted && f.month.errors && f.month.errors.pattern">This field has invalid value</span>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="vatCerts">
            <div class="col">
              <div class="form-group">
                <label for="vatCertId" translate>VAT Certificates</label>
                <div class="input-group">
                  <select [ngClass]="{'is-invalid': f.vatCertId.errors && pdfDownloadSubmitted}" formControlName="vatCertId" class="form-control" id="vatCertId">
                    <option value="-1" translate>Self</option>
                    <!--suppress TypeScriptUnresolvedVariable -->
                    <option *ngFor="let c of vatCerts" [value]="c.id">{{c.licenseName}}</option>
                  </select>
                </div>
                <small class="form-text text-muted" translate>This is the month of the report.</small>
                <span class="invalid-feedback" *ngIf="pdfDownloadSubmitted && f.month.errors && f.month.errors.required">This field is required</span>
                <span class="invalid-feedback" *ngIf="pdfDownloadSubmitted && f.month.errors && f.month.errors.pattern">This field has invalid value</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <button *ngIf="!submittingPdfDownload" class="btn btn-primary" translate (click)="submitPdfDownloadForm()">Download</button>&nbsp;&nbsp;&nbsp;&nbsp;
              <div *ngIf="submittingPdfDownload" class="mx-auto spinner-grow text-info loader-lg"></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
